import { selectionDescriptions, labelsSelectionsSupported, legendsSelectionsSupported, multiCollectionSelections, multiCollectionMaximums, selectionLimits, configOverrides, maxSelections, selectionTextOverrides, selectionGuides } from '@/features/WidgetEdit/settings';
export const questionSelectionsConfig = {
  descriptions: selectionDescriptions.question,
  textOverrides: selectionTextOverrides.question,
  multiCollectionSelections: multiCollectionSelections.question,
  selectionLimits: selectionLimits.question,
  maxSelections: maxSelections.question,
  labelsSelectionsSupported: labelsSelectionsSupported.question,
  legendsSelectionsSupported: legendsSelectionsSupported.question,
  configOverrides: configOverrides.question,
  selectionGuides: selectionGuides.question
};
export const piedoughnutSelectionsConfig = {
  descriptions: selectionDescriptions.piedoughnut,
  textOverrides: selectionTextOverrides.piedoughnut,
  multiCollectionSelections: multiCollectionSelections.piedoughnut,
  selectionLimits: selectionLimits.piedoughnut,
  maxSelections: maxSelections.piedoughnut,
  labelsSelectionsSupported: labelsSelectionsSupported.piedoughnut,
  legendsSelectionsSupported: legendsSelectionsSupported.piedoughnut,
  configOverrides: configOverrides.piedoughnut,
  selectionGuides: selectionGuides.piedoughnut
};
export const stackedbarsSelectionsConfig = {
  descriptions: selectionDescriptions.stackedbars,
  textOverrides: selectionTextOverrides.stackedbars,
  multiCollectionSelections: multiCollectionSelections.stackedbars,
  selectionLimits: selectionLimits.stackedbars,
  maxSelections: maxSelections.stackedbars,
  labelsSelectionsSupported: labelsSelectionsSupported.stackedbars,
  legendsSelectionsSupported: legendsSelectionsSupported.stackedbars,
  configOverrides: configOverrides.stackedbars,
  selectionGuides: selectionGuides.stackedbars
};
export const listSelectionsConfig = {
  descriptions: selectionDescriptions.list,
  textOverrides: selectionTextOverrides.list,
  multiCollectionSelections: multiCollectionSelections.list,
  selectionLimits: selectionLimits.list,
  maxSelections: maxSelections.list,
  labelsSelectionsSupported: labelsSelectionsSupported.list,
  legendsSelectionsSupported: legendsSelectionsSupported.list,
  configOverrides: configOverrides.list,
  selectionGuides: selectionGuides.list
};
export const overviewSelectionsConfig = {
  descriptions: selectionDescriptions.overview,
  textOverrides: selectionTextOverrides.overview,
  multiCollectionSelections: multiCollectionSelections.overview,
  selectionLimits: selectionLimits.overview,
  maxSelections: maxSelections.overview,
  labelsSelectionsSupported: labelsSelectionsSupported.overview,
  legendsSelectionsSupported: legendsSelectionsSupported.overview,
  configOverrides: configOverrides.overview,
  selectionGuides: selectionGuides.overview
};
export const tableSelectionsConfig = {
  descriptions: selectionDescriptions.table,
  textOverrides: selectionTextOverrides.table,
  multiCollectionSelections: multiCollectionSelections.table,
  selectionLimits: selectionLimits.table,
  maxSelections: maxSelections.table,
  multiCollectionMaximums: multiCollectionMaximums.table,
  labelsSelectionsSupported: labelsSelectionsSupported.table,
  legendsSelectionsSupported: legendsSelectionsSupported.table,
  configOverrides: configOverrides.table,
  selectionGuides: selectionGuides.table
};
export const treemapSelectionsConfig = {
  descriptions: selectionDescriptions.treemap,
  textOverrides: selectionTextOverrides.treemap,
  multiCollectionSelections: multiCollectionSelections.treemap,
  selectionLimits: selectionLimits.treemap,
  maxSelections: maxSelections.treemap,
  labelsSelectionsSupported: labelsSelectionsSupported.treemap,
  legendsSelectionsSupported: legendsSelectionsSupported.treemap,
  configOverrides: configOverrides.treemap,
  selectionGuides: selectionGuides.treemap
};
export const bubbleSelectionsConfig = {
  descriptions: selectionDescriptions.bubble,
  textOverrides: selectionTextOverrides.bubble,
  multiCollectionSelections: multiCollectionSelections.bubble,
  selectionLimits: selectionLimits.bubble,
  maxSelections: maxSelections.bubble,
  labelsSelectionsSupported: labelsSelectionsSupported.bubble,
  legendsSelectionsSupported: legendsSelectionsSupported.bubble,
  configOverrides: configOverrides.bubble,
  selectionGuides: selectionGuides.bubble
};
export const barChartSelectionsConfig = {
  descriptions: selectionDescriptions.barchart,
  textOverrides: selectionTextOverrides.barchart,
  multiCollectionSelections: multiCollectionSelections.barchart,
  selectionLimits: selectionLimits.barchart,
  maxSelections: maxSelections.barchart,
  labelsSelectionsSupported: labelsSelectionsSupported.barchart,
  legendsSelectionsSupported: legendsSelectionsSupported.barchart,
  configOverrides: configOverrides.barchart,
  selectionGuides: selectionGuides.barchart
};
export const stackedBarChartSelectionsConfig = {
  descriptions: selectionDescriptions.stackedbarchart,
  textOverrides: selectionTextOverrides.stackedbarchart,
  multiCollectionSelections: multiCollectionSelections.stackedbarchart,
  selectionLimits: selectionLimits.stackedbarchart,
  maxSelections: maxSelections.stackedbarchart,
  labelsSelectionsSupported: labelsSelectionsSupported.stackedbarchart,
  legendsSelectionsSupported: legendsSelectionsSupported.stackedbarchart,
  configOverrides: configOverrides.stackedbarchart,
  selectionGuides: selectionGuides.stackedbarchart
};
export const lineChartSelectionsConfig = {
  descriptions: selectionDescriptions.linechart,
  textOverrides: selectionTextOverrides.linechart,
  multiCollectionSelections: multiCollectionSelections.linechart,
  selectionLimits: selectionLimits.linechart,
  maxSelections: maxSelections.linechart,
  labelsSelectionsSupported: labelsSelectionsSupported.linechart,
  legendsSelectionsSupported: legendsSelectionsSupported.linechart,
  configOverrides: configOverrides.linechart,
  selectionGuides: selectionGuides.linechart
};
export const scatterSelectionsConfig = {
  descriptions: selectionDescriptions.scatter,
  textOverrides: selectionTextOverrides.scatter,
  multiCollectionSelections: multiCollectionSelections.scatter,
  selectionLimits: selectionLimits.scatter,
  maxSelections: maxSelections.scatter,
  labelsSelectionsSupported: labelsSelectionsSupported.scatter,
  legendsSelectionsSupported: legendsSelectionsSupported.scatter,
  configOverrides: configOverrides.scatter,
  selectionGuides: selectionGuides.scatter
};
export const receiptSelectionsConfig = {
  descriptions: selectionDescriptions.receipt,
  textOverrides: selectionTextOverrides.receipt,
  multiCollectionSelections: multiCollectionSelections.receipt,
  selectionLimits: selectionLimits.receipt,
  maxSelections: maxSelections.receipt,
  multiCollectionMaximums: multiCollectionMaximums.receipt,
  labelsSelectionsSupported: labelsSelectionsSupported.receipt,
  legendsSelectionsSupported: legendsSelectionsSupported.receipt,
  configOverrides: configOverrides.receipt,
  selectionGuides: selectionGuides.receipt
};
export const gaugeChartSelectionsConfig = {
  descriptions: selectionDescriptions.gauge,
  textOverrides: selectionTextOverrides.gauge,
  multiCollectionSelections: multiCollectionSelections.gauge,
  selectionLimits: selectionLimits.gauge,
  maxSelections: maxSelections.gauge,
  multiCollectionMaximums: multiCollectionMaximums.gauge,
  labelsSelectionsSupported: labelsSelectionsSupported.gauge,
  legendsSelectionsSupported: legendsSelectionsSupported.gauge,
  configOverrides: configOverrides.gauge,
  selectionGuides: selectionGuides.gauge
};
export const radarChartSelectionsConfig = {
  descriptions: selectionDescriptions.radar,
  textOverrides: selectionTextOverrides.radar,
  multiCollectionSelections: multiCollectionSelections.radar,
  selectionLimits: selectionLimits.radar,
  maxSelections: maxSelections.radar,
  labelsSelectionsSupported: labelsSelectionsSupported.radar,
  legendsSelectionsSupported: legendsSelectionsSupported.radar,
  configOverrides: configOverrides.radar,
  selectionGuides: selectionGuides.radar
};
const selectionsConfigs = {
  Question: questionSelectionsConfig,
  PieDoughnut: piedoughnutSelectionsConfig,
  StackedBars: stackedbarsSelectionsConfig,
  List: listSelectionsConfig,
  Overview: overviewSelectionsConfig,
  Table: tableSelectionsConfig,
  TreeMap: treemapSelectionsConfig,
  BarChart: barChartSelectionsConfig,
  StackedBarChart: stackedBarChartSelectionsConfig,
  LineChart: lineChartSelectionsConfig,
  AreaChart: lineChartSelectionsConfig,
  Receipt: receiptSelectionsConfig,
  Bubble: bubbleSelectionsConfig,
  Scatter: scatterSelectionsConfig,
  GaugeChart: gaugeChartSelectionsConfig,
  RadarChart: radarChartSelectionsConfig
};
export default selectionsConfigs;